module.exports = __webpack_public_path__ + "img/avatar4.d44a2e94.png";